import Drawer from '@components/ui/Drawer'
import styles from './styles.module.scss'
import { ReactComponent as CloseIcon } from '@svgs/keyline/close.svg'
import { Address } from '@components/account/types'
import { DrawerStateProps, UpdateAddress } from './UpdateAddress'
import { AddAddress } from './AddAddress'
import { ManageCustomerDetails } from './ManageCustomerDetails'
import { CustomerDetailsData } from '../config'

type FormDataMap = {
  details: {
    firstName?: string
    lastName?: string
    phoneNumber?: string
    id?: string
    email?: string
  }
  defaultAddress: Address
  address: Address
  'add address': null
}

export type DrawerState = {
  show: boolean
  type: keyof FormDataMap | ''
  data: FormDataMap[keyof FormDataMap]
}

export function AccountDetailsDrawer({
  drawerState,
  handleCloseAccountDetailsDrawer
}: {
  drawerState: DrawerState
  handleCloseAccountDetailsDrawer: () => void
}) {
  return (
    <Drawer
      size="medium"
      isDrawerOpen={drawerState.show}
      onCloseDrawer={handleCloseAccountDetailsDrawer}
    >
      <div className={styles.DrawerWrapper}>
        <button
          onClick={handleCloseAccountDetailsDrawer}
          className={styles.closeButton}
          name="close-account-details-drawer"
          type="button"
          aria-label="Close Account Details Drawer"
        >
          <CloseIcon />
        </button>
        {drawerState.type === 'details' &&
          drawerState.data &&
          'firstName' in drawerState.data && (
            <ManageCustomerDetails
              drawerState={drawerState as { data: CustomerDetailsData }}
              handleCloseAccountDetailsDrawer={handleCloseAccountDetailsDrawer}
            />
          )}

        {drawerState?.type === 'address' &&
          drawerState?.data &&
          'address1' in drawerState.data && (
            <UpdateAddress
              drawerState={drawerState as unknown as { data: DrawerStateProps }}
              handleCloseAccountDetailsDrawer={handleCloseAccountDetailsDrawer}
            />
          )}

        {drawerState?.type === 'add address' && (
          <AddAddress
            handleCloseAccountDetailsDrawer={handleCloseAccountDetailsDrawer}
          />
        )}
      </div>
    </Drawer>
  )
}
